import { getCurrencySymbol } from "@angular/common";

export class CurrencyHelper {

  // Using Stripe for online payments. List of supported currencies by Stripe: https://stripe.com/docs/currencies
  static getSymbolMap() {
    // Don't forget to update the api CurrencyHelper. Perhaps a future TODO is to move it all api side
    return {
      cad: '$',
      usd: '$',
      gbp: '£',
      eur: '€',
      nzd: '$',
      aud: '$',
      mxn: '$',
    };
  }

  static getSymbolForCurrency(code: string = 'cad') {
    return getCurrencySymbol(code, 'narrow');
  }

  static roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  }

  static convertToDecimal(value: number, decimalPlaces: number = 3) {
    return +(+value).toFixed(decimalPlaces);
  }

  static convertToDollar(value: number) {
    if (value < 0) {
      value = value * -1;
    }
    return (this.convertToDecimal(value)).toFixed(2);
  }

  static convertToDollarFromString(value: string) {
    if (value == null) {
      value = "0";
    }
    var stripped = value.replace(new RegExp("\\,", "g"), "");
    return (this.convertToDecimal(+stripped)).toFixed(2);
  }
}
